import type { Context, Transitions } from "../types"

type ProgramChangeEvent = Extract<Transitions, { type: "CHANGE_PROGRAM" }>

// True when a CHANGE_PROGRAM event carries the same program + subject the machine
// already has (undefined and null subject both mean "no subject"). The CHANGE_PROGRAM
// no-op branch pairs this with a courses-loaded check to skip a redundant reload that
// would flash the landing/overview page. See Ready#5031.
export const isSameProgramAndSubject = (
  ctx: Context,
  evt: ProgramChangeEvent
): boolean =>
  evt.program === ctx.program && (evt.subject ?? null) === (ctx.subject ?? null)
